import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

type archiveQuery = {
  query: string;
};

export async function archiveSilobagService({ query: rawQuery }: archiveQuery) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.post(ENDPOINT.SILOBAGS_ARCHIVABLE, { query });

  return {
    response,
    summary: data,
  };
}
